var _path, _rect, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.293 15.95h-1.85a.925.925 0 00-.925.924v1.85c0 .51.414.925.925.925h1.851c.511 0 .925-.414.925-.925v-1.85a.926.926 0 00-.926-.925zM32.557 15.95h-1.851a.925.925 0 00-.925.924v1.85c0 .51.414.925.925.925h1.851c.511 0 .925-.414.925-.925v-1.85a.925.925 0 00-.925-.925z",
    fill: "#504FE9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 30,
    width: 8,
    height: 28,
    rx: 4,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 30,
    width: 8,
    height: 28,
    rx: 4,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31H23a2 2 0 00-2 2v29a2 2 0 002 2h4a2 2 0 012 2v9c0 5 8.5 5 8.5 0v-9a2 2 0 012-2h2a2 2 0 012 2v9c0 4.5 8.5 5 8.5 0v-9a2 2 0 012-2h4a2 2 0 002-2V33a2 2 0 00-2-2zM59.916 23.993c-1.935-22.786-36.858-22.363-38.83.002C20.99 25.095 21.897 26 23 26h35c1.105 0 2.01-.906 1.916-2.007z",
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 8.5l-4-7.5m20 7.5l4-7.5",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgAndroid;